import React from 'react'
import { ScrollView, View } from 'react-native'
import { colors } from 'infra/color'
import { observer } from 'mobx-react'
import { Body1, Body3, SectionTitle } from 'ui/common/text'
import { ColumnLayout, RowLayout } from 'ui/common/layout'
import styled from 'styled-components'
import { CategoryChip } from 'ui/discovery/category-chip'
import { CategorySelectStore } from 'store/category-select'
import { Place, UnreportedPlace } from 'infra/type'
import NaverMapView from 'react-native-nmap'
import { PlaceMarker } from 'ui/common/place-marker'

export const PlaceAddEdit: React.FC<{
  place: Place | UnreportedPlace
  store: CategorySelectStore
  bottomStartAt: number
}> = observer(({ place, store, bottomStartAt }) => {
  return (
    <ScrollView style={{ paddingHorizontal: 16 }}>
      <NewPlaceBox>
        <NaverMapView
          style={{
            width: '100%',
            height: 200,
            marginBottom: 16,
          }}
          center={{
            latitude: Number(place.coord.lat),
            longitude: Number(place.coord.lng),
            zoom: 15.5,
          }}
          rotateGesturesEnabled={false}
          scrollGesturesEnabled={false}
          stopGesturesEnabled={false}
          tiltGesturesEnabled={false}
          zoomControl={false}
        >
          <PlaceMarker
            // @ts-ignore
            place={{ ...place, categories: store.leaf ? [store.leaf] : [] }}
            hidePreference
          />
        </NaverMapView>
        <Body1
          style={{
            fontWeight: 'bold',
            color: colors.gray.v800,
            marginBottom: 2,
          }}
        >
          {place.name}
        </Body1>
        {'address' in place && (
          <Body3 style={{ color: colors.gray.v700 }}>{place.address}</Body3>
        )}
      </NewPlaceBox>
      <ColumnLayout style={{ paddingHorizontal: 10 }}>
        <SectionTitle style={{ marginBottom: 16 }}>
          장소 카테고리를 선택해주세요!
        </SectionTitle>
        <RowLayout style={{ flexWrap: 'wrap' }}>
          {store.data.map((x) => (
            <CategoryChip
              key={x.id}
              isActive={true}
              isSelected={store.leaf === x.id}
              data={x}
              onPress={() => {
                store.selectInitData([])
                store.selectL1Category(x)
              }}
            />
          ))}
        </RowLayout>
      </ColumnLayout>
      <View style={{ height: bottomStartAt + 80 }} />
    </ScrollView>
  )
})

const NewPlaceBox = styled(ColumnLayout)`
  background-color: #f7f7f7;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 32px;
`
